<template>
    <div>
        <!-- <img class="bg-img" src="@/assets/v2/login.jpg"> -->
        <div class="bg-wrapper">
            <div class="login">
                <van-nav-bar class="nav-bar">
                    <template #left>
                        <van-icon name="chat-o" @click="toService()" color="#1989fa" />
                        <!-- <van-icon name="arrow-left" color="#fff" @click="back()" /> -->
                    </template>
                    <template #right>
                        <div style="background: #1989fa; border-radius: 50%;" @click="switchLanguage">
                            <img src="@/assets/v2/changeLang.png" style="width: 32px; display: block;">
                        </div>
                    </template>
                </van-nav-bar>
                <div class="wrapper">
                    <!-- <div class="logo-container">
                        <div class="logo-wrapper">
                            <img
                                class="logo-img"
                                :src="this.$store.getters.getBaseInfo.ico !== undefined ? 'https://houtai.fcwr1.com' + this.$store.getters.getBaseInfo.ico:'/img/null.png'"
                            >
                        </div>
                    </div> -->
                    <van-image width="100%" v-if="$i18n.locale == 'ja'"
                        :src="config.baseURL + $store.getters.getBaseInfo.ico" fit="cover"></van-image>
                    <van-image width="100%" v-else-if="$i18n.locale == 'ko'"
                        :src="config.baseURL + $store.getters.getBaseInfo.ko_ico" fit="cover"></van-image>
                    <van-image width="100%" v-else :src="config.baseURL + $store.getters.getBaseInfo.en_ico"
                        fit="cover"></van-image>
                    <div class="title">{{ $t('login') }}</div>
                    <div class="loginForm">
                        <van-field v-model="username" clearable input-align="left" class="input"
                            :placeholder="$t('userNamePlaceholder')" />
                        <van-field v-model="password" :type="passwordType" input-align="left" class="input"
                            :placeholder="$t('passwordPlaceholder')">
                            <template slot="right-icon">
                                <van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                                    @click="switchPasswordType" />
                            </template>
                        </van-field>
                        <!-- <div class="reset-text">
                            <span>{{ $t('forgotPassword') }}</span>
                        </div> -->
                        <div @click="toRegister()" class="register-text">
                            <span>{{ $t('noAccount') }} {{ $t('registerNow') }}</span>
                        </div>
                        <van-button class="login-btn" type="primary" size="normal" @click="doLogin()">{{ $t('login')
                            }}</van-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from "../../http/config";
export default {
    model: {
        prop: 'inputValue',
        event: 'input'
    },
    props: {
        /**
         * 当前输入的值
         */
        inputValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            config,
            username: '',
            password: this.inputValue,
            passwordType: 'password',
        };
    },
    methods: {
        toService() {
            if (this.$i18n.locale == "ja") {
                return window.location.href = this.$store.getters.getBaseInfo.kefu;
            } else if (this.$i18n.locale == "ko") {
                return window.location.href = this.$store.getters.getBaseInfo.ko_kefu;
            } else if (this.$i18n.locale == "en") {
                return window.location.href = this.$store.getters.getBaseInfo.en_kefu;
            }
        },
        switchPasswordType() {
            this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
        },
        back() {
            return window.history.back();
        },
        toRegister() {
            this.$router.push("Register")
        },
        doLogin() {
            if (this.username === "" || this.username === null || this.username === undefined) {
                this.$toast(this.$t('userNamePlaceholder') + "");
                return false;
            }
            if (this.password === "" || this.password === null || this.password === undefined) {
                this.$toast(this.$t('passwordPlaceholder') + "");
                return false;
            }
            this.$http({
                method: 'get',
                data: { username: this.username, password: this.password },
                url: 'member_login'
            }).then(res => {
                if (res.code === 200) {
                    this.$toast(res.msg);
                    localStorage.setItem('token', res.data.id)
                    this.$router.push("Home")
                } else {
                    this.$toast(res.msg);
                }
            })
        },
        switchLanguage() {
            this.$router.push({ path: '/SwitchLanguage', query: { fromPage: 'login' } });
        },
    },
    created() {
        if (localStorage.getItem('token')) {
            return window.history.back();
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.nav-bar {
    background: transparent;
}

.login {
    height: 100vh;
    background: aliceblue;
}

.login .wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 80px;
}

.logo-container {
    margin: 0 auto;
    width: 45%;
}

.logo-container .logo-wrapper {
    position: relative;
    padding-bottom: 62.5%;
}

.logo-container .logo-wrapper .logo-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
}

.login .wrapper .title {
    line-height: 100px;
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    color: #1989fa;
    letter-spacing: 5px;
}

.login .wrapper .loginForm {
    padding: 60px;
}

.login .wrapper .loginForm .input {
    padding: 0 20px;
    margin-top: 40px;
    // border-radius: 50px;
    text-align: center;
    line-height: 80px;
    font-size: 30px;
    color: #000;
    background: rgba(255, 255, 255, 0.5);
}

::v-deep .login .wrapper .loginForm .van-field__control::-webkit-input-placeholder {
    color: #000;
}

::v-deep .login .wrapper .loginForm .van-field__control::-moz-placeholder {
    color: #000;
}

::v-deep .login .wrapper .loginForm .van-field__control:-ms-input-placeholder {
    color: #000;
}

::v-deep .login .wrapper .loginForm .van-field__control::-ms-input-placeholder {
    color: #000;
}

::v-deep .login .wrapper .loginForm .van-field__control::placeholder {
    color: #000;
}

::v-deep .van-field__right-icon .van-icon {
    font-size: 50px;
}

::v-deep .van-icon {
    font-size: 50px;
}

.login .wrapper .loginForm .reset-text {
    margin: 30px 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.login .wrapper .loginForm .reset-text span {
    color: #fff;
    font-size: 25px;
    font-weight: 500;
    line-height: 15px;
}

.login .wrapper .loginForm .register-text {
    margin: 50px 0 70px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login .wrapper .loginForm .register-text span {
    color: #1989fa;
    font-size: 25px;
    font-weight: 500;
    line-height: 20px;
}

.login .wrapper .loginForm .active {}

.login .wrapper .loginForm .login-btn {
    // margin-top: 85px;
    width: 100%;
    height: 80px;
    // border-radius: 50px;
    color: #fff;
    background: #1989fa;
    font-size: 30px;
    font-weight: bolder;
    border: none;
}
</style>
